import api from './client';

async function fetchPhones(page = 0, perPage = 15) {
    const url = `/reserved?currentPage=${page}&perPage=${perPage}`;
    const {data} = await api.get(url);
    return data;
}

async function updatePhoneGroup(phone, group) {
    const url = '/reserved/update';
    const {data} = await api.post(url, { phone, group });
    return data;
}

async function removePhone(phone) {
    const url = `/reserved?phone=${phone}`;
    const {data} = await api.delete(url);
    return data;
}

async function createPhone(phone, group) {
    const url = '/reserved';
    const {data} = await api.post(url, { phone, group });
    return data;
}

export {
    fetchPhones,
    updatePhoneGroup,
    removePhone,
    createPhone
}
